// Local Variables
const isInMobileApp = window.nativeBabbelApp !== undefined;

// Module Exports
export { isInMobileApp };
